'use client';

import { createContext, RefObject, useContext } from 'react';
import type { SphereHandle } from './types';

/** Shared handle to the mounted SphereCanvas — scenes drive the sphere through this ref. */
export const SphereHandleContext =
  createContext<RefObject<SphereHandle | null> | null>(null);

export function useSphereHandle(): RefObject<SphereHandle | null> {
  const ctx = useContext(SphereHandleContext);
  if (!ctx) {
    throw new Error(
      'useSphereHandle must be used within EmeraldSphereExperience',
    );
  }
  return ctx;
}
